import { axiosHelper } from 'Services/AxiosHelper';
import { setDefaultCardBodyData } from 'Config';
import { getApiGWTokenCookie } from 'Utils';

const command = 'b2c.SetDefaultCard';
const setDefaultCard = async (params: setDefaultCardBodyData): Promise<any> =>
  (
    await axiosHelper({
      method: 'post',
      gatewayData: {
        command,
        token: getApiGWTokenCookie(),
      },
      data: params,
    })
  ).data;

export default setDefaultCard;
